import '../../gs-core/common/util/array.prototype';
import { DocUpload } from './DocUpload';
import { DocUploadStep, DocUploadSteps } from './DocUploadStep';

export const CONCURRENT_UPLOADS = 5;

export interface DocUploadMap {
  map: { [stepCode: string]: DocUpload[] };
  flatten: () => DocUpload[];
  byStep: (step: DocUploadStep) => DocUpload[];
  transition: (docUpload: DocUpload, step: DocUploadStep) => void;
}

export const DocUploadMapModel = {
  create(docUploads: DocUpload[]): DocUploadMap {
    const map = createMap(docUploads);
    return { map, flatten, transition, byStep: byStep };
  },
};

function createMap(docUploads: DocUpload[]) {
  return DocUploadSteps.DISPLAY_ORDER.reduce(
    (map: DocUploadMap, step: DocUploadStep) => {
      map[step.code] = docUploads.filter(docUpload => docUpload.step.code === step.code);
      return map;
    },
    {} as any
  );
}

function transition(this: DocUploadMap, docUpload: DocUpload, step: DocUploadStep) {
  const srcList = this.byStep(docUpload.step);

  const index = srcList.indexOf(docUpload);

  if (index < 0) {
    throw new Error('Could not find docUpload index in upload map');
  }

  srcList.splice(index, 1);

  docUpload.step = step;
  const destList = this.byStep(step);
  destList.push(docUpload);
}

function flatten(this: DocUploadMap): DocUpload[] {
  return Object.keys(this.map).flatMap(stepCode => this.map[stepCode]);
}

function byStep(this: DocUploadMap, step: DocUploadStep) {
  return this.map[step.code];
}



// WEBPACK FOOTER //
// ./src/common/models/DocUploadMap.ts